module.exports = __webpack_public_path__ + "img/grey_pin.36309306.svg";